import { useNavigate } from "react-router-dom";
import { Clock, MapPin, Users } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { toHijri } from "@/lib/hijri";
import { useLang, catLabel } from "@/lib/i18n";

export const EventCard = ({ event, slug, hijriOffset = 0 }) => {
  const navigate = useNavigate();
  const { t, lang } = useLang();
  const d = new Date(event.start);
  const hijri = toHijri(event.start, hijriOffset);
  const locale = lang === "fr" ? "fr-FR" : "en-US";

  return (
    <button
      data-testid="event-card"
      onClick={() => navigate(`/${slug}/events/${event.id}`)}
      className="w-full text-left flex gap-4 p-4 rounded-lg border border-border bg-card hover-lift"
    >
      <div className="shrink-0 w-16 text-center rounded-md border border-border overflow-hidden">
        <div className="text-[10px] font-mono-data uppercase py-0.5 text-white" style={{ background: event.display_color || event.mosque_color || "#2563EB" }}>
          {d.toLocaleDateString(locale, { month: "short" })}
        </div>
        <div className="font-heading font-extrabold text-2xl leading-tight pt-1">{d.getDate()}</div>
        <div className="text-[10px] font-mono-data text-muted-foreground pb-1">{hijri.day} {hijri.monthName.split(" ")[0]}</div>
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="font-heading font-bold truncate">{event.title}</h3>
          <Badge variant="secondary" className="text-[10px] uppercase tracking-wide">{catLabel(t, event.category)}</Badge>
        </div>
        <div className="flex items-center gap-3 mt-1.5 text-xs text-muted-foreground flex-wrap">
          <span className="flex items-center gap-1 font-mono-data">
            <Clock className="h-3 w-3" />
            {d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" })}
          </span>
          {event.mosque_name && (
            <span className="flex items-center gap-1">
              <span className="h-2 w-2 rounded-full" style={{ background: event.mosque_color }} />
              {event.mosque_name}
            </span>
          )}
          {event.registrations_count > 0 && (
            <span className="flex items-center gap-1">
              <Users className="h-3 w-3" /> {event.registrations_count}
            </span>
          )}
          {event.location && (
            <span className="flex items-center gap-1 truncate">
              <MapPin className="h-3 w-3" /> {event.location}
            </span>
          )}
        </div>
        {event.description && <p className="text-sm text-muted-foreground mt-1.5 line-clamp-2">{event.description}</p>}
      </div>
    </button>
  );
};
